export const NOT_AN_OBJECT_ERROR =
  "JsonApiParser: first parameter has to be an object";
export const NOT_JSON_API_COMPLIANT_ERROR =
  "JsonApiParser: json object passed as attribute should follow the type/attributes structure";
export const DATA_EMPTY_ERROR = "JsonApiParser: data key is empty";
